// extracted by mini-css-extract-plugin
export var $animation_name = "TextRow-module--$animation_name--3dee1";
export var Inner = "TextRow-module--Inner--72bad";
export var Inner__blurb = "TextRow-module--Inner__blurb--fb944";
export var Inner__title = "TextRow-module--Inner__title--f58ed";
export var Wrapper = "TextRow-module--Wrapper--dc0b3";